/* Exposes a window.boomi.flow global with all globally accessible properties */
import './js/globals';
import { startup } from './js/startup';
import './css/flow.css';

await startup();
